// extracted by mini-css-extract-plugin
export default {"root":"Placeholder_root__grCoV","highlight":"Placeholder_highlight__QE-c4"};